import { useGoals } from 'features/goals';
import { useMemo } from 'react';

export const useTextFilteredGoals = (searchText: string) => {
  const goals = useGoals();

  return useMemo(() => {
    if (!searchText) {
      return [];
    }
    const trimmedSearchText = searchText.trim().toLowerCase();

    return goals
      .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [searchText, goals]);
};
